module.exports = __webpack_public_path__ + "img/survey.ec7c0413.svg";